export var TcfEuV2Field;
(function (TcfEuV2Field) {
    TcfEuV2Field["VERSION"] = "Version";
    TcfEuV2Field["CREATED"] = "Created";
    TcfEuV2Field["LAST_UPDATED"] = "LastUpdated";
    TcfEuV2Field["CMP_ID"] = "CmpId";
    TcfEuV2Field["CMP_VERSION"] = "CmpVersion";
    TcfEuV2Field["CONSENT_SCREEN"] = "ConsentScreen";
    TcfEuV2Field["CONSENT_LANGUAGE"] = "ConsentLanguage";
    TcfEuV2Field["VENDOR_LIST_VERSION"] = "VendorListVersion";
    TcfEuV2Field["POLICY_VERSION"] = "PolicyVersion";
    TcfEuV2Field["IS_SERVICE_SPECIFIC"] = "IsServiceSpecific";
    TcfEuV2Field["USE_NON_STANDARD_STACKS"] = "UseNonStandardStacks";
    TcfEuV2Field["SPECIAL_FEATURE_OPTINS"] = "SpecialFeatureOptins";
    TcfEuV2Field["PURPOSE_CONSENTS"] = "PurposeConsents";
    TcfEuV2Field["PURPOSE_LEGITIMATE_INTERESTS"] = "PurposeLegitimateInterests";
    TcfEuV2Field["PURPOSE_ONE_TREATMENT"] = "PurposeOneTreatment";
    TcfEuV2Field["PUBLISHER_COUNTRY_CODE"] = "PublisherCountryCode";
    TcfEuV2Field["VENDOR_CONSENTS"] = "VendorConsents";
    TcfEuV2Field["VENDOR_LEGITIMATE_INTERESTS"] = "VendorLegitimateInterests";
    TcfEuV2Field["PUBLISHER_RESTRICTIONS"] = "PublisherRestrictions";
    TcfEuV2Field["PUBLISHER_PURPOSES_SEGMENT_TYPE"] = "PublisherPurposesSegmentType";
    TcfEuV2Field["PUBLISHER_CONSENTS"] = "PublisherConsents";
    TcfEuV2Field["PUBLISHER_LEGITIMATE_INTERESTS"] = "PublisherLegitimateInterests";
    TcfEuV2Field["NUM_CUSTOM_PURPOSES"] = "NumCustomPurposes";
    TcfEuV2Field["PUBLISHER_CUSTOM_CONSENTS"] = "PublisherCustomConsents";
    TcfEuV2Field["PUBLISHER_CUSTOM_LEGITIMATE_INTERESTS"] = "PublisherCustomLegitimateInterests";
    TcfEuV2Field["VENDORS_ALLOWED_SEGMENT_TYPE"] = "VendorsAllowedSegmentType";
    TcfEuV2Field["VENDORS_ALLOWED"] = "VendorsAllowed";
    TcfEuV2Field["VENDORS_DISCLOSED_SEGMENT_TYPE"] = "VendorsDisclosedSegmentType";
    TcfEuV2Field["VENDORS_DISCLOSED"] = "VendorsDisclosed";
})(TcfEuV2Field || (TcfEuV2Field = {}));
export const TCFEUV2_CORE_SEGMENT_FIELD_NAMES = [
    TcfEuV2Field.VERSION,
    TcfEuV2Field.CREATED,
    TcfEuV2Field.LAST_UPDATED,
    TcfEuV2Field.CMP_ID,
    TcfEuV2Field.CMP_VERSION,
    TcfEuV2Field.CONSENT_SCREEN,
    TcfEuV2Field.CONSENT_LANGUAGE,
    TcfEuV2Field.VENDOR_LIST_VERSION,
    TcfEuV2Field.POLICY_VERSION,
    TcfEuV2Field.IS_SERVICE_SPECIFIC,
    TcfEuV2Field.USE_NON_STANDARD_STACKS,
    TcfEuV2Field.SPECIAL_FEATURE_OPTINS,
    TcfEuV2Field.PURPOSE_CONSENTS,
    TcfEuV2Field.PURPOSE_LEGITIMATE_INTERESTS,
    TcfEuV2Field.PURPOSE_ONE_TREATMENT,
    TcfEuV2Field.PUBLISHER_COUNTRY_CODE,
    TcfEuV2Field.VENDOR_CONSENTS,
    TcfEuV2Field.VENDOR_LEGITIMATE_INTERESTS,
    TcfEuV2Field.PUBLISHER_RESTRICTIONS,
];
export const TCFEUV2_PUBLISHER_PURPOSES_SEGMENT_FIELD_NAMES = [
    TcfEuV2Field.PUBLISHER_PURPOSES_SEGMENT_TYPE,
    TcfEuV2Field.PUBLISHER_CONSENTS,
    TcfEuV2Field.PUBLISHER_LEGITIMATE_INTERESTS,
    TcfEuV2Field.NUM_CUSTOM_PURPOSES,
    TcfEuV2Field.PUBLISHER_CUSTOM_CONSENTS,
    TcfEuV2Field.PUBLISHER_CUSTOM_LEGITIMATE_INTERESTS,
];
export const TCFEUV2_VENDORS_ALLOWED_SEGMENT_FIELD_NAMES = [
    TcfEuV2Field.VENDORS_ALLOWED_SEGMENT_TYPE,
    TcfEuV2Field.VENDORS_ALLOWED,
];
export const TCFEUV2_VENDORS_DISCLOSED_SEGMENT_FIELD_NAMES = [
    TcfEuV2Field.VENDORS_DISCLOSED_SEGMENT_TYPE,
    TcfEuV2Field.VENDORS_DISCLOSED,
];
